import * as React from 'react';
import { IOptionProps } from '@components/option';
import { OptionList } from '@components/option-list';
import { Dropdown } from '@components/dropdown';
import { OptionListHeader } from '@components/option-list-header';

import { PopoutPlacement } from '@hooks';
import { WithChildrenCommonProps } from '@types';

export type IDropdownOption<T> = {
  label: string;
  leftContent?: JSX.Element;
  value: string;
} & T;

export type IDropdownOptionList = WithChildrenCommonProps<{
  /** Defines the width of the Dropdown element */
  dropdownWidth?: number | string;
  /** Indicates if the dropdown is opened */
  isOpen: boolean;
  /** Indicates the number of items to be displayed in the dropdown when it is opened */
  maxVisibleOptions?: number;
  /** Text to display in the header of the option list */
  optionsHeaderText?: string;
  /** Function to be executed when changing the selected value */
  onChange: (value: IDropdownOption<unknown>) => void;
  /** Function to be executed when clicking outside the dropdown */
  onClickAway: VoidFunction;
  /** Indicates the position of the dropdown relative to the TextField */
  placement?: PopoutPlacement;
  /** Reference of the element from which the dropdown is going to be shown */
  reference: HTMLElement | null;
}>;

export const DropdownOptionList = ({
  children,
  dataId,
  isOpen,
  maxVisibleOptions = 5,
  optionsHeaderText,
  onChange,
  onClickAway,
  placement = 'bottom-start',
  reference,
  ...rest
}: IDropdownOptionList): JSX.Element => {
  return (
    <Dropdown
      data-id={dataId}
      isOpen={isOpen}
      onClickAway={onClickAway}
      placement={placement}
      reference={reference}
      {...rest}
    >
      {optionsHeaderText && (
        <OptionListHeader>{optionsHeaderText}</OptionListHeader>
      )}

      <OptionList maxVisibleOptions={maxVisibleOptions} addHalfOption={true}>
        {React.Children.toArray(children).map(
          // @ts-ignore
          (option: React.ReactElement<IOptionProps>) =>
            React.cloneElement(option, {
              // @ts-ignore
              onClick: (
                event: React.MouseEvent<HTMLButtonElement>,
                value: IDropdownOption<unknown>
              ) => {
                option.props.onClick && option.props.onClick(event, value);
                reference?.focus();
                onChange(value);
              },
            })
        )}
      </OptionList>
    </Dropdown>
  );
};
